module.exports = __webpack_public_path__ + "static/media/chat_01.f0447c9a.png";